import React from 'react'
import "./aboutautored.scss"
const Aboutautored = () => {
  return (
    <div className='aboutred'>
      <h2>
      About AutoRed
      </h2>
      <p>
      Aenean pellentesque mollis ante sed ornare. Vivamus in blandit ipsum. Etiam a dapibus arcu. Integer at fermentum mauris. Proin vulputate dui ac consequat varius. Duis dui nibh, maximus in finibus in, fringilla sit amet mauris. Donec interdum nibh quis feugiat tempus. Vestibulum ornare hendrerit maximus. Duis rutrum porta libero. Nullam libero velit, interdum vel eros non, facilisis consequat magna. Maecenas hendrerit vel felis vel porttitor. Duis sollicitudin metus in maximus sodales. Sed ac eros sit amet tortor rhoncus convallis. Nulla ut est et urna tincidunt semper a sit amet elit. Etiam euismod nunc libero, ac dignissim arcu sodales id. Pellentesque venenatis ligula non diam accumsan, at pellentesque massa dapibus.
      </p>
    </div>
  )
}

export default Aboutautored
